import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { roleStringList, roleToString, stringToRole, UserRole } from "utils/role";

const TableHeader = ({
  selectedRole,
  onChangeRole,
}: {
  selectedRole?: UserRole;
  onChangeRole?: (role: number) => void;
}) => {
  const role = selectedRole ? roleToString(selectedRole) : undefined;

  return (
    <Container>
      <div style={{ gap: "32px", display: "flex" }}>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{ width: "191px" }}
        >
          이름
        </UI.Typography>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{ width: "191px" }}
        >
          이메일
        </UI.Typography>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{ width: "191px" }}
        >
          연동
        </UI.Typography>
        <UI.SelectBox
          key={role}
          selectedData={role === undefined ? [""] : [role]}
          onChange={(value: string[]) => onChangeRole?.(stringToRole(value[0]))}
          width={200}
          data={roleStringList}
          renderSelectBox={() => {
            return (
              <div style={{ display: "flex", gap: "12px", width: "191px", alignItems: "center" }}>
                <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
                  <p>권한</p>
                </UI.Typography>
                <UI.Icon name="chevronDown" size={16} color="var(--alias-color-label-normal)"></UI.Icon>
              </div>
            );
          }}
        ></UI.SelectBox>
      </div>
      <UI.Typography
        type="label01"
        fontStyle="medium"
        color="var(--alias-color-label-normal)"
        style={{ width: "160px" }}
      >
        관리
      </UI.Typography>
    </Container>
  );
};

export default TableHeader;

const Container = styled.div`
  display: flex;
  padding: 12px 24px;
  justify-content: space-between;
  border-radius: 12px;
  background-color: var(--component-color-fill-alternative);
`;
